import "./blogs.css";
import React, { useState, useEffect } from "react";
import chauwkVideoImage from "../../assets/images/chauwkVideoImage.png";
import eenaduImage from "../../assets/images/eenaduImage.png";
import way2WorldImage from "../../assets/images/WaytonewsImage.png";

const reviews = [
  {
    quote: "Eenadu",
    link: "https://www.eenadu.net/telugu-news/business/general/0101/123103167",
    type: "image",
    image: eenaduImage,
  },
  {
    quote: "YouTube",
    link: "https://www.youtube.com/embed/4OKYVDxDnm8",
    type: "video",
  },
  {
    quote: "Way2World",
    link: "http://www.way2world.in/chauwk",
    type: "image",
    image: way2WorldImage,
  },
];

const VideoPlayer = ({ image, videoUrl }) => {
  const [showVideo, setShowVideo] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowVideo(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="video-container">
      {showVideo ? (
        <iframe
          width="100%"
          height="100%"
          src={`${videoUrl}?autoplay=1&mute=1`}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="Chauwk Video"
        ></iframe>
      ) : (
        <img src={image} alt="Thumbnail" className="video-thumbnail" />
      )}
    </div>
  );
};

const GetInvolvedBlogs = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerSlide, setItemsPerSlide] = useState(3);

  // 🧩 Adjust items per slide based on screen width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setItemsPerSlide(1);
      } else if (window.innerWidth <= 1024) {
        setItemsPerSlide(2);
      } else {
        setItemsPerSlide(3);
      }
    };

    handleResize(); // run on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev + itemsPerSlide >= reviews.length ? 0 : prev + itemsPerSlide
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev - itemsPerSlide < 0
        ? reviews.length - itemsPerSlide
        : prev - itemsPerSlide
    );
  };

  return (
    <section className="reviews-container">
      <div className="carousel">
        {reviews.length > itemsPerSlide && (
          <button className="arrow left" onClick={prevSlide}>
            &#10094;
          </button>
        )}
        <div className="slider-container">
          <div
            className="reviews-wrapper slide-effect"
            style={{
              transform: `translateX(-${
                currentIndex * (100 / itemsPerSlide)
              }%)`,
            }}
          >
            {reviews.map((review, index) => (
              <div key={index} className="review-card">
                {review.type === "video" ? (
                  <VideoPlayer
                    image={chauwkVideoImage}
                    videoUrl={review.link}
                  />
                ) : review.type === "image" ? (
                  <img
                    src={review.image}
                    alt={review.quote}
                    className={`static-thumbnail ${
                      review.quote === "Way2World" ? "way2world-img" : ""
                    }`}
                    onClick={() => window.open(review.link, "_blank")}
                  />
                ) : (
                  <h4
                    className="clickable-link"
                    onClick={() => window.open(review.link, "_blank")}
                  >
                    {review.quote}
                  </h4>
                )}
              </div>
            ))}
          </div>
        </div>
        {reviews.length > itemsPerSlide && (
          <button className="arrow right" onClick={nextSlide}>
            &#10095;
          </button>
        )}
      </div>
    </section>
  );
};

export default GetInvolvedBlogs;
